module.exports = __webpack_public_path__ + "img/octa-googleplay.be27f9fa.png";